import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import FlatButton from "material-ui/FlatButton";
import getMuiTheme from "material-ui/styles/getMuiTheme";
// import Industry
// import dialog
import IndustryDialog from "./IndustryDialog";
// import common dialog for successing invited.

// table
import ClientsTable from "./ClientsTable";
import { buttonBlueColor } from "../../utils/utility";

// client profile
import ClientProfile from "./ClientProfile";
// css
import "./clients.css";

class Client extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.throttle_clientName = true;
    this.throttle_accountManager = true;
    this.throttle_client_options = true;
    this.state = {
      open: false, // if open dialog
      showClientProfile: false,
    };
  }
  componentDidMount() {
    this.props.getIndustryOptions(); // get industry option for clientProfile
    this.props.getTierOptions(); // get tier options for industry dialog component.
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.roleId === 5) {
      if (this.throttle) {
        nextProps.history.push("/");
        this.throttle = false;
      }
    }

    if (
      /^(system administrator|account manager|operations manager|administrator)/gi.test(
        this.props.roleName,
      ) &&
      this.throttle_client_options
    ) {
      this.props.get_client_options(); // get role optionss for industry dialog component.
      this.throttle_client_options = false;
    }
    if (
      /^system administrator/gi.test(this.props.roleName) &&
      this.throttle_accountManager
    ) {
      this.props.getAccountManage();
      this.throttle_accountManager = false;
    }
    if (/^(administrator|team member)/gi.test(this.props.roleName)) {
      // request one time
      if (this.throttle) {
        if (nextProps.loginUserDetail) {
          nextProps.getBusinessUnitOptions(); // get business unit options
          nextProps.getTeamMember(nextProps.loginUserDetail.client.id); // get business assign to data for ClientProfile component.
          this.throttle = false;
        }
      }
    }

    if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
      if (this.throttle_clientName) {
        nextProps.getClientName(); // get client names for IndustryDialog component.
        this.throttle_clientName = false;
      }
    }
    if (nextProps.ifSendInvitationSuccess) {
      this.setState({
        open: false,
      });
    }

    if (nextProps.roleId === 5) {
      this.props.history.push("/");
    }

    if (nextProps.roleId === 53) {
      this.props.history.push("/");
    }
  }
  handleCloseDialog() {
    this.setState({
      open: false,
    });
  }
  handleOpenDialog() {
    this.setState({
      open: true,
    });
  }

  handleSendInvite() {}

  handleInviteAnotherClient(selectedItem, clients) {
    this.setState({
      open: true,
    });
  }
  handleCreateClientProfile() {
    this.setState({
      showClientProfile: true,
    });
  }
  clientProfileCancel() {
    this.setState({
      showClientProfile: false,
    });

    if (
      /^(system administrator|account manager|operations manager|administrator)/gi.test(
        this.props.roleName,
      )
    ) {
      this.props.get_client_options(); // get role optionss for industry dialog component.
      this.throttle_client_options = false;
    }
    if (/^system administrator/gi.test(this.props.roleName)) {
      this.props.getAccountManage();
    }
    if (/^(administrator|team member)/gi.test(this.props.roleName)) {
      this.props.getTeamMember(); // get business assign to data for ClientProfile component.
      this.props.getBusinessUnitOptions(); // get business unit options
    }
    if (/^(system administrator|account manager)/gi.test(this.props.roleName)) {
      this.props.getClientName();
    }
  }

  render() {
    const muiTheme = getMuiTheme({
      menuItem: {
        hoverColor: buttonBlueColor(),
      },
    });

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div
          className="ac-clients"
          style={{ padding: this.state.showClientProfile ? "0" : "" }}
        >
          {/*clients table*/}
          {/*if showCLientProfile is true, show ClientProfile component*/}
          {!this.state.showClientProfile ? (
            <div className="ac-clients-lines">
              <ClientsTable
                getClientsTable={this.props.getClientsTable}
                tableData={this.props.tableData}
                getIndustryOptions={this.props.getIndustryOptions}
                industryOptions={this.props.industryOptions}
                search_clients={this.props.getClientsTable}
                roleName={this.props.roleName}
                getAllClientsTable={this.props.getAllClientsTable}
                tableAllData={this.props.tableAllData}
              />
              {/*end*/}
              <div className="btns">
                {/*
                  <FlatButton
                    label={/^(administrator|team member)/gi.test(this.props.roleName) ? 'INVITE BUSINESS UNIT TEAM MEMBER' : "INVITE CLIENT"}
                    backgroundColor={buttonBlueColor()}
                    labelStyle={{color: 'white', fontWeight:'normal', fontSize: '13px', padding: 0}}
                    hoverColor={buttonBlueColor()}
                    style={{marginRight: '10px', height: '30px', lineHeight: 'auto', padding: '0 9px'}}
                    onClick={() => this.handleOpenDialog()}
                />*/}
                {/^(administrator|team member)/gi.test(this.props.roleName) && (
                  <FlatButton
                    label={"Invite Business Unit Team Member"}
                    backgroundColor={buttonBlueColor()}
                    labelStyle={{
                      color: "white",
                      fontWeight: "normal",
                      fontSize: "16px",
                      textTransform: "capitalize",
                      padding: 20,
                    }}
                    hoverColor={buttonBlueColor()}
                    style={{
                      marginRight: "10px",
                      height: "40px",
                      lineHeight: "auto",
                      padding: "0 9px",
                    }}
                    onClick={() => this.handleOpenDialog()}
                  />
                )}
                <FlatButton
                  label={
                    /^(administrator|team member)/gi.test(this.props.roleName)
                      ? "Create Business Unit Profile"
                      : "Create  Client Profile"
                  }
                  labelStyle={{
                    fontWeight: "normal",
                    color: "white",
                    padding: 20,
                    fontSize: "16px",
                    textTransform: "capitalize",
                  }}
                  hoverColor={buttonBlueColor()}
                  backgroundColor={buttonBlueColor()}
                  style={{
                    fontWeight: "normal",
                    lineHeight: "auto",
                    height: "40px",
                    padding: "0 9px",
                  }}
                  onClick={() => this.handleCreateClientProfile()}
                />
              </div>
              <IndustryDialog
                open={this.state.open}
                roleName={this.props.roleName}
                handleCloseDialog={() => this.handleCloseDialog()}
                ifSendInvitationSuccess={this.props.ifSendInvitationSuccess}
                handleSendInvite={() => this.handleSendInvite()}
                industryOptions={this.props.industryOptions}
                tier_options={this.props.tier_options}
                account_manager={this.props.account_manager}
                send_invitation={this.props.send_invitation}
                send_invitation_error_msg={this.props.send_invitation_error_msg}
                invitation_client={this.props.invitation_client}
                client_options={
                  /^(team member)/gi.test(this.props.roleName)
                    ? [
                        { value: 51, label: "Administrator" },
                        { value: 52, label: "Team Member" },
                        { value: 53, label: "Business Unit Team Member" },
                      ]
                    : this.props.client_options
                }
                handleInviteAnotherClient={() =>
                  this.handleInviteAnotherClient()
                }
                rollbackStatus={this.props.rollbackStatus}
                client_names={this.props.client_names}
                businessUnitOptions={this.props.businessUnitOptions}
                inviteBusinessMember={this.props.inviteBusinessMember}
              />
            </div>
          ) : (
            <ClientProfile
              ifCreateClientProfileSuccessBasic={
                this.props.ifCreateClientProfileSuccessBasic
              }
              clientId={this.props.clientId}
              configInsightsStandard={this.props.configInsightsStandard}
              getConfigInsightsStandard={this.props.getConfigInsightsStandard}
              path={this.props.match.path}
              roleInfo={this.props.roleName}
              getStates={this.props.getStates}
              allstates={this.props.allstates}
              getTimezone={this.props.getTimezone}
              timezone={this.props.timezone}
              getRoles={this.props.getRoles}
              roles={this.props.roles}
              clientProfileCancel={() => this.clientProfileCancel()}
              ifUpdateSuccess={this.props.ifUpdateSuccess}
              loginUserDetail={this.props.loginUserDetail}
              tier_options={this.props.tier_options}
              industryOptions={this.props.industryOptions}
              token={this.props.token}
              roleName={this.props.roleName}
              account_manager={this.props.account_manager}
              createClientProfile={this.props.createClientProfile}
              createClientProfileMessage={this.props.createClientProfileMessage}
              ifCreateClientProfileSuccess={
                this.props.ifCreateClientProfileSuccess
              }
              rollbackProfileStatus={this.props.rollbackProfileStatus}
              teamMember_options={this.props.teamMember_options} // for business assign array data
            />
          )}
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Client;



// WEBPACK FOOTER //
// ./src/components/Clients/Index.jsx